//@flow

import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import {classNames} from '../../utils/react';

const useStyles = makeStyles(() => ({
  switch: {
    position: 'relative',
    display: 'inline-flex',
    alignItems: 'center',
    gap: '8px',
    '&.disabled': {
      opacity: '.5',
      pointerEvents: 'none',
    },
  },
  switchInput: {
    appearance: 'none',
    WebkitAppearance: 'none',
    width: '46px',
    height: '28px',
    background: '#b8b8c7',
    borderRadius: '999px',
    position: 'relative',
    outline: 'none',
    cursor: 'pointer',
    transition: '.2s',
    '&:after': {
      content: '""',
      position: 'absolute',
      height: '20px',
      width: '20px',
      left: '4px',
      top: '4px',
      background: 'white',
      borderRadius: '50%',
      transition: '.2s',
    },
    '&$checked': {
      background: 'linear-gradient(90deg, #31c48d, #22c1a7)',
    },
    '&$checked:after': {
      transform: 'translateX(18px)',
    },
    '@media (prefers-reduced-motion: reduce)': {
      transition: 'none',
      '&:after': {
        transition: 'none',
      },
    },
  },
  checked: {},
  switchText: {
    fontSize: '12px',
    color: '#8b93a7',
  },
  small: {
    '& $switchInput': {
      width: '36px',
      height: '20px',
      '&:after': {
        height: '14px',
        width: '14px',
        left: '3px',
        top: '3px',
      },
      '&$checked:after': {
        transform: 'translateX(16px)',
      },
    },
    '& $switchText': {
      fontSize: '11px',
    },
  },
  medium: {
    // Default size styles are already defined in switchInput
  },
}));

type SwitchProps = {
  label?: React$Node,
  size?: 'small' | 'medium',
} & React.InputHTMLAttributes<HTMLInputElement>;

export function TiendadaSwitch(props: SwitchProps) {
  const {label, checked, disabled, onChange, size, ...restProps} = props;

  const classes = useStyles();

  return (
    <label
      className={classNames(classes.switch, {
        [classes.disabled]: disabled,
        [classes.small]: size === 'small',
        [classes.medium]: size === 'medium',
      })}
    >
      <input
        type="checkbox"
        className={classNames(classes.switchInput, {
          [classes.checked]: checked,
        })}
        checked={checked}
        disabled={disabled}
        onChange={onChange}
        {...restProps}
      />
      {label && <span className={classes.switchText}>{label}</span>}
    </label>
  );
}
